<template>
	<svg class="vsvg"><use :xlink:href="'#' + sprite"></use><title v-if="title" role="presentation">{{title}}</title></svg>
</template>

<script>
	// In Vue 3, event listeners registered on the component fall through to the root element automatically (the old v-on="$listeners" is no longer needed).
	// Do not add comments inside the template block: they would make the component fragment-rooted in development builds.
	export default {
		props:
		{
			sprite: {
				type: String,
				required: true
			},
			title: {
				type: String,
				default: ""
			}
		}
	}
</script>